var StaticEvents = /** @class */ (function () {
    function StaticEvents() {
    }
    StaticEvents.events = {};
    return StaticEvents;
}());
export { StaticEvents };
